import { useTranslation } from '../../i18n/useTranslation.js';

import { Button } from './Button.jsx';
import { Modal } from './Modal.jsx';

/**
 * On-brand confirmation popup (replaces window.confirm).
 * @param {{
 *   open: boolean,
 *   title: string,
 *   message: string,
 *   confirmLabel: string,
 *   cancelLabel?: string,
 *   variant?: 'primary' | 'danger',
 *   isPending?: boolean,
 *   onConfirm: () => void,
 *   onClose: () => void,
 * }} props
 */
export function ConfirmDialog({
  open,
  title,
  message,
  confirmLabel,
  cancelLabel,
  variant = 'primary',
  isPending = false,
  onConfirm,
  onClose,
}) {
  const { t } = useTranslation();
  return (
    <Modal
      open={open}
      title={title}
      onClose={onClose}
      footer={
        <>
          <Button variant="ghost" onClick={onClose} disabled={isPending}>
            {cancelLabel || t('common.cancel')}
          </Button>
          <Button variant={variant} onClick={onConfirm} disabled={isPending}>
            {isPending ? `${confirmLabel}…` : confirmLabel}
          </Button>
        </>
      }
    >
      <p className="muted" style={{ margin: 0 }}>{message}</p>
    </Modal>
  );
}
